import { Component } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {Router} from '@angular/router';
import {AuthService} from "../../services/api/auth/auth.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    FormsModule,
    NgIf
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {
  username: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(private router: Router,
              private authService: AuthService) {}

  onSubmit() {
    this.authService.loginUser(this.username, this.password).subscribe( res => {
      this.authService.setToken(res.username, res.access_token);
      this.router.navigate(['/']);
    },
      error => {
        this.errorMessage = "Misy diso ny anarana na ny teny miafina";
      }
    );
  }
}
